import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="footer" className="mt-24">
      <div className="px-4 md:px-6 py-10 flex flex-wrap items-center justify-between gap-6 hairline-t">
        <div className="flex items-center gap-4">
          <span className="ab-logo shrink-0">AK</span>
          <div>
            <div className="heavy text-lg">AK.ARCHIVE</div>
            <div className="mono text-[11px] text-ink-muted mt-1">A curated intelligence vault · ak-archive.com</div>
          </div>
        </div>
        <div className="flex flex-wrap gap-2">
          <Link to="/dossiers" className="pill pill-sm">Dossiers</Link>
          <Link to="/new" className="pill pill-sm">New</Link>
          <Link to="/search" className="pill pill-sm">Search</Link>
          <Link to="/admin/login" className="pill pill-sm">Admin</Link>
        </div>
      </div>
      <div className="px-4 md:px-6 py-3 mono text-[10px] uppercase tracking-[0.14em] text-ink-faint flex justify-between items-center">
        <span>REF // <span className="text-yellow">2026</span></span>
        <span>END OF TRANSMISSION</span>
      </div>
    </footer>
  );
}
